module.exports = __webpack_public_path__ + "img/5986d2a0bc9de5d97d4496fbdeefc0c0.png";